<template>
    <el-dialog class="el-dialogs" :append-to-body="true" :title="title" width="800px" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules" label-width="110px">
            <div class="flex_l_c flex_w">
                <el-form-item label="入库点交人" prop="delivererBy" style="width: 48%">
                    <el-select v-model="searchForm.delivererBy"
                               placeholder="请选择入库点交人" style="width: 100%"
                               clearable>
                        <el-option
                                v-for="item in delivererByList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="入库接收人" prop="receiverBy" style="width: 48%">
                    <el-select v-model="searchForm.receiverBy"
                               placeholder="请选择入库接收人" style="width: 100%"
                               clearable>
                        <el-option
                                v-for="item in delivererByList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="交接时间" prop="receiverTime" style="width: 48%">
                    <el-date-picker
                            style="width: 100%"
                            v-model="searchForm.receiverTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择交接时间">
                    </el-date-picker>
                </el-form-item>
            </div>
            <div class="minTitle">出库藏品：</div>
            <el-table
                    :data="dataList2"
                    size="small" height="250px"
                    class="table" ref="multipleTable" border
                    row-key='id' v-loading="loading">
                <el-table-column prop="dataName" label="资源名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="orderItemId" label="入库编号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="warehouseId" label="存放库房" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-select v-model="row.warehouseId" @change="changeWarehouseId(row)" size="mini"
                                   style="width: 90%" clearable placeholder="请选择存放库房">
                            <el-option
                                    v-for="item in warehouseIdList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="shelfId" label="存放位置" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-select v-model="row.shelfId" size="mini" style="width: 90%" clearable
                                   placeholder="请选择存放库房">
                            <el-option
                                    v-for="item in row.shelfIdList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
            </el-table>
            <pagination :total="total" :page.sync="current" :limit.sync="size"
                        @pagination="refreshList()"/>
        </el-form>
        <div slot="footer" class="text_right">
            <el-button size="small" type="primary" @click="sureData()" v-noMoreClick>确定</el-button>
            <el-button size="small" @click="visible = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "sureStore",
    data() {
        return {
            title: '批量接收入库',
            visible: false,
            searchForm: {
                delivererBy: '',
                receiverBy: '',
                receiverTime: '',
            },
            rules: {
                delivererBy: [
                    {required: true, message: '请选择入库交接人', trigger: 'change'}
                ],
                receiverBy: [
                    {required: true, message: '请选择入库接收人', trigger: 'change'}
                ],
                receiverTime: [
                    {required: true, message: '选择交接时间', trigger: 'change'}
                ],
            },
            delivererByList: [],
            loading: false,
            dataList: [],
            dataList2: [],
            current: 1,
            size: 20,
            total: 0,
            selectData: {},

            warehouseIdList: [],
        }
    },

    methods: {
        init(row) {
            this.visible = true
            this.selectData = row
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields()
            })
            this.current = 1
            this.size = 20
            this.getOtherData()
            this.getDetail()
        },

        getOtherData() {
            this.$axios(this.api.user.queryUserListAllUsable).then(data => {
                if (data && data.status) {
                    this.delivererByList = data.data
                }
            })
            this.$axios(this.api.collection.collectionwarehouseAllWarehouse).then(data => {
                if (data && data.status) {
                    this.warehouseIdList = data.data
                }
            })
        },

        getDetail() {
            this.loading = true
            this.$axios(this.api.collection.receiveInfo, {
                ids: [this.selectData.id],
            }, 'post').then(data => {
                if (data && data.status) {
                    this.dataList = data.data
                    this.dataList.forEach(item => {
                        this.$set(item, 'shelfIdList', [])
                    })
                    this.refreshList()
                }
                this.loading = false
            })
        },

        refreshList() {
            let newArray = [...this.dataList]
            this.dataList2 = newArray.splice((this.current - 1) * this.size, this.current * this.size)
        },

        changeWarehouseId(row) {
            row.shelfId = ''
            if (row.warehouseId) {
                this.$axios(this.api.collection.getByWarehouseId + row.warehouseId).then(data => {
                    if (data && data.status) {
                        row.shelfIdList = data.data
                    }
                })
            } else {
                row.shelfIdList = []
            }
        },

        sureData() {
            let kongData = this.dataList.filter(item => item.warehouseId == '')
            if (kongData.length) {
                this.$message.error('请选择藏品的存放库房')
                return
            }
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    this.$axios(this.api.collection.collectioninwarehouseReceive, {
                        ...this.searchForm,
                        list: this.dataList
                    }, 'post').then(data => {
                        if (data && data.status) {
                            this.$message.success('接收入库成功')
                            this.visible = false
                            this.$emit('refresh')
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }
            });
        },
    },
}
</script>

<style scoped>
.minTitle {
    width: 110px;
    text-align: right;
}
</style>